import { isAuthenticated } from '../auth/index'

/**
 * Guard для защищенных маршрутов
 * 
 * Проверяет авторизацию пользователя и редиректит на страницу профиля,
 * если пользователь не авторизован. Сохраняет текущий путь в query параметре
 * `redirect` для последующего возврата после авторизации.
 * 
 * @param initData - initData строка от Telegram Web App SDK
 * 
 * @example
 * Использование в компоненте:
 * ```tsx
 * const { initData } = useTelegram()
 * requireAuth(initData)
 * ```
 * 
 * Или в beforeLoad (если initData доступен через context):
 * ```tsx
 * beforeLoad: ({ context }) => {
 *   requireAuth(context.initData)
 * }
 * ```
 * 
 * @throws Не выбрасывает ошибки, но выполняет редирект через window.location
 */
export function requireAuth(initData: string | null | undefined) {
  if (!isAuthenticated(initData)) {
    const currentPath = window.location.pathname + window.location.search
    // Используем window.location для редиректа, так как redirect() требует сгенерированные типы
    window.location.href = `/profile?redirect=${encodeURIComponent(currentPath)}`
  }
}

